import { createApiClient } from 'Network/ApiClient';

export const ActivityCodeAxiosInstance = createApiClient('ActivityCode/');


